import {
    APPROVED_BOOKING,
    BOOKING_APPROVAL_LIST,
    BOOKING_CHECK_IN_USER,
    BOOKING_DETAILS,
    BOOKING_FRONTDESK_LIST,
    BOOKING_REQUEST_LIST,
    CHECK_IN_BOOKING,
    CREATE_ROOM_AVAILABLE_LIST,
    DELETE_REQUEST,
    DELETE_ROOM_AVAILABLE_LIST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    REJECTED_BOOKING,
    ROOM_AVAILABLE_LIST,
    ROOM_BOOKING_LOGS_LIST,
    UPDATE_ROOM_AVAILABLE_LIST,
} from "shared/constants/ActionTypes";
const initialState = {
    loading: true,
    error: null,
    bookingRequestList: [],
    bookingDetails: null,
    bookingApprovalList: [],
    bookingFrontDeskList: [],
    bookingCheckInUserList: [],
    availableBookingRoomList: [],
    roomBookingLogsList: [],
};
export const roomBookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true };
        case FETCH_SUCCESS:
            return { ...state, loading: false };
        case FETCH_ERROR:
            return { ...state, error: action.payload, loading: false };
        case BOOKING_REQUEST_LIST:
            return {
                ...state,
                bookingRequestList: action.payload,
                bookingDetails: null,
            };
        case BOOKING_DETAILS:
            return {
                ...state,
                bookingDetails: action.payload,
                bookingRequestList: [],
            };
        case BOOKING_APPROVAL_LIST:
            return {
                ...state,
                bookingApprovalList: action.payload,
            };
        case ROOM_BOOKING_LOGS_LIST:
            return {
                ...state,
                roomBookingLogsList: action.payload,
            };
        case CREATE_ROOM_AVAILABLE_LIST:
            return {
                ...state,
                availableBookingRoomList: [
                    action.payload[0],
                    ...state.availableBookingRoomList,
                ],
            };
        case ROOM_AVAILABLE_LIST:
            return {
                ...state,
                availableBookingRoomList: action.payload,
            };
        case UPDATE_ROOM_AVAILABLE_LIST:
            return {
                ...state,
                availableBookingRoomList: [
                    ...state.availableBookingRoomList.map((item) =>
                        item.id === action.payload.id
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
            };
        case DELETE_ROOM_AVAILABLE_LIST:
            return {
                ...state,
                availableBookingRoomList: state.availableBookingRoomList.filter(
                    (el) => el.id !== action.payload.id
                ),
            };
        case BOOKING_FRONTDESK_LIST:
            return {
                ...state,
                bookingFrontDeskList: action.payload,
            };
        case BOOKING_CHECK_IN_USER:
            return {
                ...state,
                bookingCheckInUserList: action.payload,
            };
        case DELETE_REQUEST:
            return {
                ...state,
                bookingRequestList: state.bookingRequestList.filter(
                    (el) => el.bookingId !== action.payload.bookingId
                ),
            };
        case APPROVED_BOOKING:
            return {
                ...state,
                bookingApprovalList: state.bookingApprovalList.filter(
                    (el) => el.bookingId !== action.payload.bookingId
                ),
                bookingDetails:
                    state.bookingDetails.bookingId == action.payload.bookingId
                        ? {
                              ...action.payload,
                          }
                        : state.bookingDetails,
            };
        case REJECTED_BOOKING:
            return {
                ...state,
                bookingApprovalList: state.bookingApprovalList.filter(
                    (el) => el.bookingId !== action.payload.bookingId
                ),
                bookingDetails:
                    state.bookingDetails.bookingId == action.payload.bookingId
                        ? {
                              ...action.payload,
                          }
                        : state.bookingDetails,
            };
        case CHECK_IN_BOOKING:
            return {
                ...state,
                bookingFrontDeskList: [
                    ...state.bookingFrontDeskList.map((item) =>
                        item.bookingId === action.payload.bookingId
                            ? { ...action.payload.data }
                            : item
                    ),
                ],
                bookingDetails: {
                    ...action.payload.data,
                },
            };
        default:
            return state;
    }
};
